<template>
  <!-- MODALE DOWNLOAD STATO CREDITI RESIDUI SINGOLI UTENTI -->
  <b-modal
      ref="credres_modal"
      title="Credito Residuo Utenti"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      v-model="open_close_modal">

      <p class="text-justify">Permette di controllare lo stato attuale dei crediti attivi per tutti gli utenti
          aziendali. Premere il pulsante <i>"Esegui"</i> per avviare il donwload</p>
      <p class="text-justify">Gli utenti che riportano il simbolo "<b>----</b>"" nelle colonne dei crediti non hanno
          attualmente crediti in corso di validità.</p>
      <p class="text-justify"><b>L'export potrebbe richiedere alcuni secondi per essere completato</b></p>

      <!-- Rimpiazziamo il footer standard con dei bottoni personalizzati.       -->
      <!-- In particolare il il pulsante di OK modifica la sua forma durante il  -->
      <!-- download, informando l'utente che quest'ultimo è in corso.            -->
      <template #modal-footer>
        <b-button variant="primary" @click="esegui_export" :disabled="disable_on_download">
            <span v-if="!disable_on_download">Esegui</span>
            <span v-else><b-spinner small class="mr-1" :variant="'light'"></b-spinner> Download in corso</span>
        </b-button>
        <b-button @click="open_close_modal=false" :disabled="disable_on_download">Annulla</b-button>
      </template>
  </b-modal>
</template>

<script>
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'
import fileDownload from 'js-file-download'

export default {
  name: 'CresResUsersDownloadModal',
  data () {
    return {
        // Flag disattivazione elementi finestra durante lo scaricamento
        disable_on_download : false
    }
  },
  methods: {
    /**
     * Richiama al vista Django che a sua volta richiama il modulo
     * liwe delle apghe per eseguire l'estrazione welfarebridge.
     * I dati scaricati sono sia quelli delle transazioni in stato 6
     * che storicizzate.
     * Per scaricare file con axios abbiamo usato la libreria js-file-download prendendo spunto
     * da: https://stackoverflow.com/questions/41938718/how-to-download-files-using-axios
     */
    esegui_export : function (){

      // Disabilito gli elementi della finestra durante il donwload.
      this.disable_on_download = true;

      // Impostiamo axios con l'url da chiemare e dicendogli di aspettarsi
      // una risposta di tipo blob ritornando il server un file.
      axios.get( apiUrl.welfareapi.export_crediti_res_utenti, { responseType: 'blob' } )
      .then( ( response ) => {
        // Prendiamo il nome dall'header content-disposition
        let nome_file = generalLib.get_nome_file( response );
        // Usiamo js-file-donwload per salvare il file sul client
        fileDownload( response.data, nome_file );
        // Riabilitiamo gli elementi della finestra e chiudiamo la modale
        this.open_close_modal = false;
        this.disable_on_download = false;
      })
      .catch( (error) => {
        this.disable_on_download = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });
    }
  },
  computed : {
    /* Questa computed può essere anche settata ed è di supporto al v-model, viene
       agganciata al v-model della b-modal per aprirla e chiuderla.
       Quando il valore della prop viene settato ( a true ad esempio perchè vogliamo
       aprire la modale ), viene eseguito il metodo get che restituisce il valore
       stesso della property ( true ) ed apre la modale.
       Al click sul pulsante "chiudi" la computed viene settata a false ( voglio chiudere
       la modale ), questo fa si che sia eseguito il set il quale emette l'evento close
       e torna il valore false.
       Avendo definito in "model" l'evento close come evento di update del v-model,
       registrato l'evento, il suo valore (false) viene settato nella property dal chiamante
       e la finestra si chiude! In questo modo la propery non viene mutata direttamente da
       dal componente stesso. */
    open_close_modal : {
      get() {
        return this.show_modal;
      },
      set(value) {
        this.$emit( 'close', value );
      }
    }
  },
  /* Definendo model possiamo agganciare al componente un suo v-model,
     il quale, pilotato dal componente parent può aprire o chiudere la finestra.
     Il valore del v-model sarà sempre passato alla prop show_modal, allo scattare
     dell'evento close il v-model sarà updatato.
     In questo modo si evita la modifica da dentro il componente della
     prop che è un antipattern e viene segnalato come errore. */
  model : {
    prop: 'show_modal',
    event: 'close'
  },
  props : {
    /**
     * Booleano che indica se visualizzare o meno la modale.
     */
    show_modal : {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
</style>